import React from "react";
import Instagram from "../../assets/instagram.png";
import Logo from "../../assets/logo.png";
import { legalLinks } from "../../config/legalLinks";
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-brand">
                    <img src={Logo} alt="Grind'On" className="footer-logo" />
                    <p className="brand-pitch">Bhaktapur's elite training facility. Dedicated to pushing boundaries and building champions.</p>
                    <div className="social-links">
                        <a href="https://www.instagram.com/grind.on__" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={Instagram} alt="Instagram" />
                        </a>
                    </div>
                </div>

                <div className="footer-links-group">
                    <h4 className="outfit">Location & Contact</h4>
                    <p>Bhaktapur, Sallaghari</p>
                    <p>+977 9863032963</p>
                    <p>+977 9818950290</p>
                </div>

                <div className="footer-links-group">
                    <h4 className="outfit">Legal</h4>
                    <div className="legal-links">
                        <a href={legalLinks.privacy}>Privacy Policy</a>
                        <a href={legalLinks.terms}>Terms of Service</a>
                        <a href={legalLinks.eula}>EULA</a>
                        <a href={legalLinks.support}>Support</a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <hr />
                <p>&copy; {currentYear} Grind'On Strength & Fitness. All rights reserved.</p>
            </div>

            <div className="blur footer-blur-1"></div>
            <div className="blur footer-blur-2"></div>
        </footer>
    );
};

export default Footer;
